import { useCallback } from 'react';
import { DEFAULT_RELEASE_RESOLVED_PROMISE_DELAY, withCached } from '@atlassian/people-teams/helpers';
import { useService } from '@atlassian/people-teams/hooks';
import { fetchInactiveUsers } from '../clients/experimentApiClient';
import { usePeopleMenuContext } from '../context/PeopleMenuContext';
const mapFetchInactiveUserFnByTimeout = new Map();
function getFetchInactiveUsersCachedFn(timeout = DEFAULT_RELEASE_RESOLVED_PROMISE_DELAY) {
  let fn = mapFetchInactiveUserFnByTimeout.get(timeout);
  if (fn) {
    return fn;
  }
  fn = withCached(fetchInactiveUsers, timeout);
  mapFetchInactiveUserFnByTimeout.set(timeout, fn);
  return fn;
}
export function usePendingUsersService(cloudId, cacheTimeout, product) {
  const {
    product: contextProduct
  } = usePeopleMenuContext();
  const request = useCallback(() => {
    if (cacheTimeout) {
      const fn = getFetchInactiveUsersCachedFn(cacheTimeout);
      return fn(cloudId, product !== null && product !== void 0 ? product : contextProduct);
    }
    return fetchInactiveUsers(cloudId, product !== null && product !== void 0 ? product : contextProduct);
  }, [cacheTimeout, cloudId, product, contextProduct]);
  const {
    loading,
    error,
    data,
    fetchData
  } = useService(request);
  return {
    loading,
    error,
    data: data === null || data === void 0 ? void 0 : data.users,
    fetchData
  };
}